import { ReactNode } from "react";
import cx from "classnames";

import { type IconComponent } from "types/Icon";
import BaseActionButton, { type BaseActionButtonProps } from "ds/components/BaseAction/Button";

import MainNavigationBaseActionContent from "./Content";
import styles from "./styles.module.css";

type MainNavigationBaseActionButtonProps = BaseActionButtonProps & {
  title: string;
  icon?: IconComponent;
  isActive?: boolean;
  isFocused?: boolean;
  transitionClasses?: string;
  children?: ReactNode;
  className?: string;
};

const MainNavigationBaseActionButton = ({
  title,
  icon,
  isActive,
  isFocused,
  transitionClasses,
  children,
  className,
  ...restProps
}: MainNavigationBaseActionButtonProps) => {
  const combinedClassName = cx(
    styles.baseAction,
    styles.baseActionButton,
    {
      [styles.baseActionActive]: isActive,
      [styles.baseActionFocused]: isFocused,
    },
    className
  );

  return (
    <BaseActionButton
      {...restProps}
      className={combinedClassName}
      justify="between"
      align="center"
      fullWidth
    >
      <MainNavigationBaseActionContent
        title={title}
        icon={icon}
        transitionClasses={transitionClasses}
      />

      {children}
    </BaseActionButton>
  );
};

export default MainNavigationBaseActionButton;
